export const latinAmericanCodes = [
  'AR',
  'BO',
  'BR',
  'CL',
  'CO',
  'EC',
  'FK',
  'GF',
  'GY',
  'PY',
  'PE',
  'SR',
  'UY',
  'VE',
]

export const latinAmericanNationalities = [
  'Argentine',
  'Bolivian',
  'Brazilian',
  'Chilean',
  'Colombian',
  'Ecuadorian',
  'Falkland Island',
  'French Guianese',
  'Guyanese',
  'Paraguayan',
  'Peruvian',
  'Surinamese',
  'Uruguayan',
  'Venezuelan',
]
